// extracted by mini-css-extract-plugin
module.exports = {"theme":"#6eb3f9"};